'use client';

import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Link from 'next/link';

import { faqs } from '@/src/constants/FAQs';
import { sendAnalyticsData } from '@/src/utils/analytics';

import { FAQ } from '../Faqs/FAQ';
import type { IFAQ, IFAQTags } from '../home.interface';

export const HippaferpaFAQs = ({ tag }: IFAQTags) => {
  return (
    <div className="container mx-auto px-4 pb-16 text-center md:px-16 md:py-20 2xl:px-24">
      <div className="py-8 text-center text-[28px] font-medium text-[#000000] md:text-4xl">
        Frequently Asked Questions
      </div>
      <div className="m-auto w-[91%] md:mt-6">
        {faqs.map((faq: IFAQ, index: number) => (
          <FAQ key={index} faq={faq} _tag={tag} />
        ))}
      </div>
      <div>
        <div className="mt-8 flex flex-col items-center justify-center gap-y-1 md:flex-row md:gap-x-2 ">
          <Link
            href="/faqs"
            className="flex cursor-pointer items-center gap-x-1 self-center rounded-lg border-2 border-solid border-[#318AE5] p-4 text-[16px] font-medium text-[#318AE5] hover:bg-[#318AE5] hover:text-white"
          >
            <span>View all FAQs</span> <ChevronRightIcon className="h-5 w-5" />
          </Link>
          <Link
            href="/contact-us"
            onClick={() => {
              sendAnalyticsData(
                'CONTACT_US_BUTTON_CLICKED_FROM_HIPAA_FERPA_FAQS',
              );
            }}
            className="cursor-pointer px-6 text-[16px] font-medium text-[#318AE5] hover:text-[#2B81D9]"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
};
